import { Injectable } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { ConfigService } from '../../services/config/config.service';
import { DataService } from '../../services/data/data.service';
import { DisplayService } from '../../services/display/display.service';
import { TabService } from '../tab/tab.service';
import _ from 'lodash';

@Injectable()
export class ReportService {

	tabsData = {
		tabs: [
			{
				prop: 'invoice',
				name: 'Invoice',
				active: false,
				persona: ['pm', 'fa', 'sam'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'liability',
				name: 'Liability',
				active: false,
				persona: ['pm', 'fa', 'sam'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'timesheet',
				name: 'ILC Hours',
				active: false,
				persona: ['pm', 'tra'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'po',
				name: 'Remaining Funds',
				active: false,
				persona: ['sam', 'pm', 'cca', 'fa', 'readonly'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'contractor',
				name: 'Expiring Contractors',
				active: false,
				persona: ['sam', 'pm', 'cca', 'fa', 'readonly'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'ContractorNoTS',
				name: 'Contractors Not Claiming',
				active: false,
				persona: ['sam', 'pm', 'tra', 'cca', 'readonly'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'activeContractor',
				name: 'Active Contractors',
				active: false,
				persona: ['readonly'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}, {
				prop: 'ContractorMissTS',
				name: 'Contractors Missing Claims',
				active: false,
				persona: ['sam', 'pm', 'tra', 'fa', 'readonly'],
				notPersona: [],
				cached: false,
				listTab: false,
				type: 'standard',
				page: 0,
				sortParam: '',
				sortDir: '',
				search: false,
				searching: false,
				tableFilters: [],
				searchCount: 1
			}
		]
	};

	constructor(
		private commsService: CommsService,
		private configService: ConfigService,
		private dataService: DataService,
		private displayService: DisplayService,
		private tabService: TabService) { }

	selectDefaultTab(tabsData) {
		const self = this;
		tabsData.forEach(function (d, i) {
			tabsData[i].active = false;
			tabsData[i].cached = false;
		});
		let foundDefault = false;
		let defaultIndex = -1;
		tabsData.forEach(function (d, i) {
			if (self.tabService.showTab(d.persona, d.notPersona) && !foundDefault) {
				foundDefault = true;
				defaultIndex = i;
			}
		});
		tabsData[defaultIndex].active = true;
		console.log('SELECTED DEFAULT TAB', tabsData[defaultIndex]?.name);
	}

	getActiveTab(tabsData): any {
		let activeTab = {};
		tabsData.forEach(d => {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	tabClick(event, tabProp: string, tabsData: Array<any>): void {
		console.log('TAB CLICK', tabProp, tabsData);
		// skip if invalid tab name (this might happen when entering a bad url)
		if (!tabsData.find(d => d.prop === tabProp)) {
			return;
		}
		let foundTab = false;
		tabsData.forEach(d => {
			d.active = false;
			if (d.prop === tabProp) {
				d.active = true;
				foundTab = true;
				window.history.replaceState({}, '', '/reports/' + d.prop);
				console.log('ACTIVATE TAB', d);
			}
		});
	}

	checkTabs(tabsData) { }

	loadAllforTab(activeTab) { }

	showTabSearch(tabsData) { }

	loadAllSuppliers() {
		this.displayService.startLoading();
		this.commsService.getSuppliers().subscribe((res) => {
			console.log('LOAD ALL DIVISION CODES: ', res);
			this.displayService.endLoading();
			const successData = this.commsService.getSuccessData(res);
			this.dataService.updateSuppliers(successData);
		}, (err) => {
			this.displayService.endLoading();
			this.commsService.handleAPIError('Load All Suppliers', err);
		});
	}

	private deleteEmptyFilters(data) {
		// besides empty filters, also need delete ilcSerialnumb created by IBM serial number
		Object.keys(data).forEach(key => {
			if (data[key] === '' || key === this.configService.ilcSerialNumProp) {
				delete data[key];
			}
		});
	}

	// for cost center, we display "undefined" but the backend expects an empty string
	convertEmptyValue(data) {
		if (data.costcenter) {
			for (let i = 0; i < data.costcenter.length; i++) {
				if (data.costcenter[i] === this.dataService.emptyLabel) {
					data.costcenter[i] = '';
				}
			}
		}
	}

	exportInvoiceReports(event) {
		const self = this;
		const data = _.cloneDeep(event.data);
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		this.displayService.startLoading();
		this.commsService.getInvoiceReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Invoice Reports', err);
		});
	}

	exportLiabilityReports(event) {
		const self = this;
		const data = _.cloneDeep(event.data);
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		this.displayService.startLoading();
		this.commsService.getLiabilityReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Liability Reports', err);
		});
	}


	exportTimesheetReports(event) {
		const self = this;
		const data = event.data;
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		this.displayService.startLoading();
		this.commsService.getTimesheetReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('ILC Hours Reports', err);
		});
	}

	exportPurchaseorderReports(event) {
		const self = this;
		const data = _.cloneDeep(event.data);
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		// need convert suppliername to supplierid
		if (data.suppliername) {
			data['ccid'] = this.dataService.getSupplierCCIDbyName(data.suppliername);
			delete data['suppliername'];
		}

		console.log('EXPORT REMAINING FUNDS REPORT', data);
		this.displayService.startLoading();
		this.commsService.getPurchaseOrderReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Remaining Fund Reports', err);
		});
	}

	exportContractorReports(event) {
		const self = this;
		const data = _.cloneDeep(event.data);
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		this.displayService.startLoading();
		// need convert suppliername to ccid
		if (data.suppliername) {
			data['ccid'] = this.dataService.getSupplierCCIDbyName(data.suppliername);
			delete data['suppliername'];
		}

		console.log('EXPORT CONTRACTOR REPORT', data);
		this.commsService.getContractorReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Expiring Contractors Reports', err);
		});
	}

	exportContractorNoTSReports(event) {
		const self = this;
		const data = _.cloneDeep(event.data);
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		this.displayService.startLoading();
		// need convert suppliername to ccid
		if (data.suppliername) {
			data['ccid'] = this.dataService.getSupplierCCIDbyName(data.suppliername);
			delete data['suppliername'];
		}
		this.commsService.getContractorNoTSReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('No Claiming Contractors Reports', err);
		});
	}

	exportActiveContractorReports(event) {
		const self = this;
		const data = _.cloneDeep(event.data);
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		this.displayService.startLoading();
		// need convert suppliername to ccid
		if (data.suppliername) {
			data['ccid'] = this.dataService.getSupplierCCIDbyName(data.suppliername);
			delete data['suppliername'];
		}
		data['cancellation'] = false;
		data['category'] = 'unarchive';
		data['status'] = 'all';
		data['getActive'] = true;

		this.commsService.getActiveContractorReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Active Contractors Reports', err);
		});
	}

	exportContractorMissTSReports(event) {
		const self = this;
		const data = _.cloneDeep(event.data);
		this.deleteEmptyFilters(data);
		this.convertEmptyValue(data);
		this.displayService.startLoading();

		this.commsService.getContractorMissTSReports(data).subscribe((res) => {
			self.displayService.endLoading();
			self.commsService.saveToCSV(data.filename, res);
		}, (err) => {
			self.displayService.endLoading();
			self.commsService.handleAPIError('Contractors Missing Claims Reports', err);
		});
	}

}
